













































































































































































































































import GlobalMixin from "@/mixins/global";
import { S3 } from "@/common/s3";
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import DialogDelete from "@/components/ModalFormNewResgister/DialogDelete.vue";
import DialogDeleteActivities from "@/components/ModalFormNewResgister/DialogDeleteActivities.vue";
import DialogDeletePatronal from "@/components/ModalFormNewResgister/DialogDeletePatronal.vue";
import DialogDeleteDoc from "@/components/ModalFormNewResgister/DialogDeleteDoc.vue";
import EditRegisterSTPS from "@/components/ModalFormNewResgister/editRegisterSTPS.vue";
import EditActivities from "@/components/ModalFormNewResgister/editActivities.vue";
import EditEmployerResgister from "@/components/ModalFormNewResgister/editEmployerResgister.vue";
import EditDocument from "@/components/ModalFormNewResgister/editDocument.vue";
import Snackbar from "@/components/ModalFormNewResgister/snackbar.vue";
import AutorizationSTPS from "@/components/Autorization/AutorizationSTPSRegister.vue";
import AutorizationEmployer from "@/components/Autorization/AutorizationEmployerRegister.vue";
import AutorizationDocument from "@/components/Autorization/AutorizationDocuments.vue";
import AutorizationActivities from "@/components/Autorization/AutorizationActivities.vue";

export default GlobalMixin.extend({
  components: {
    DialogDelete,
    DialogDeleteActivities,
    DialogDeletePatronal,
    DialogDeleteDoc,
    EditRegisterSTPS,
    EditActivities,
    EditEmployerResgister,
    EditDocument,
    Snackbar,
    AutorizationSTPS,
    AutorizationEmployer,
    AutorizationDocument,
    AutorizationActivities,
  },
  props: [
    "headers",
    "items",
    "sortBy",
    "loading",
    "docuementoSeccion",
    "titleTable",
    "proveedor",
    "isActivities",
    "forceUpdate",
  ],
  data() {
    return {
      moduleName: "DATATABLE_REGISTER",
      dialog: false,
      dialogDelete: false,
      dialogRefuse: false,
      // snackbar
      snackbar: false,
      text: "",
      timeout: 2000,
      color: "",
      registroSTPS: [],
      // DATATABLES
      headerProps: {
        sortByText: "Ordenar por",
      },
      footerProps: {
        itemsPerPageText: "Registros por página",
        itemsPerPageAllText: "Todos",
        pageText: "{0}-{1} de {2}",
        sortByText: "Ordenar por",
      },
      loadingText: "Cargando... Por favor espere",
      noDataText: "Sin datos",
      // REGISTROS
      editedIndex: -1,
      editedItem: {},
      enabledEdit: 0,
      keyFileTempRefuse: "",
      renderComponent: true,
    };
  },
  methods: {
    // Es usado para actualizar los items de
    // las tablas de los documentos
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    // Metodo para obtener el item a editar
    editItem(item: object) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.enabledEdit = 0;
      // Se busca el listado de los registros STPS
      // para el formulario de actividades
      this.searchSTPSSelet();
      this.dialog = true; // Se abre el formulario de edicion
    },
    // Cierra el formulario de edicion
    closeDialog() {
      this.dialog = false;
      this.resetIndexItem();
    },
    // Abre el formulario de agregar
    openDialog() {
      this.enabledEdit = 0;
      // Se busca el listado de los registros STPS
      // para el formulario de actividades
      this.searchSTPSSelet();
      this.dialog = true;
    },
    // Selecciona el item a eliminar
    // y abre el dialogo para confirmar la eliminacion
    deleteItem(item: object) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    // Elimina el item selecionado del listado
    deleteItemConfirm() {
      this.items.splice(this.editedIndex, 1);
      // Actualiza la cantidad de documentos en el badge
      if (!this.isActivities) {
        this.$emit("deletetems");
      }
      // Actualizacion forzada (usada en las tablas de los documentos)
      if (this.forceUpdate) {
        this.forceRerender();
      }
      this.closeDelete();
    },
    // Cierra el dialogo de confirmacion
    closeDelete() {
      this.dialogDelete = false;
      this.resetIndexItem();
    },
    // Actualiza el item agregado o editado
    // Cierra formulario para agregar o editar
    saveItem() {
      if (this.editedIndex > -1) {
        // Editado
        Object.assign(this.items[this.editedIndex], this.editedItem);
      } else {
        // Agregado
        this.items.push(this.editedItem);
        // Actualiza la cantidad de documentos en el badge
        if (!this.isActivities) {
          this.$emit("addItems");
        }
        // Actualizacion forzada (usada en las tablas de los documentos)
        if (this.forceUpdate) {
          this.forceRerender();
        }
      }
      this.closeDialog();
    },
    // Descarga el archivo del S3
    async getFile(fileName: string) {
      const result: any = await S3.get(fileName);
      if (Object.keys(result).length) {
        let blob = new Blob([result.Body], { type: result.ContentType });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      } else {
        this.text = "No se encontro el archivo solicitado";
        this.snackbar = true;
        this.color = "red darken-2";
      }
    },
    // Cierra la notificacion
    closeSnackbar() {
      this.snackbar = false;
    },
    // Activar notificacion
    notificacion(mensaje: string, color: string) {
      this.text = mensaje;
      this.color = color;
      this.snackbar = true;
      window.setTimeout(() => {
        this.snackbar = false;
      }, this.timeout);
    },
    // Proceso de autorizacion del documento
    autorizar(item: any) {
      this.editedIndex = this.items.indexOf(item);
      switch (this.docuementoSeccion.documentoOrden) {
        case 1:
          if (!this.isActivities) {
            dataService
              .approveRegisterSTPS(item.registroSTPSID)
              .then((Response: ResponseData) => {
                item.registroSTPSEstatusID = 2;
                Object.assign(this.items[this.editedIndex], item);
                this.text = "Registro autorizó";
                this.snackbar = true;
                this.color = "success";
                this.resetIndexItem();
              })
              .catch((e: Error) => {
                this.$logger.warn(e);
                this.text =
                  "No se autorizó el registro, intente de nuevo más tarde";
                this.snackbar = true;
                this.color = "red darken-2";
                this.resetIndexItem();
              });
            break;
          } else if (this.isActivities) {
            dataService
              .approveActivities(item.registroActividadID)
              .then((Response: ResponseData) => {
                item.registroActividadEstatusID = 2;
                Object.assign(this.items[this.editedIndex], item);
                this.text = "Registro autorizó";
                this.snackbar = true;
                this.color = "success";
                this.resetIndexItem();
              })
              .catch((e: Error) => {
                this.$logger.warn(e);
                this.text =
                  "No se autorizó el registro, intente de nuevo más tarde";
                this.snackbar = true;
                this.color = "red darken-2";
                this.resetIndexItem();
              });
            break;
          }
        case 2:
          dataService
            .approveEmployerRegister(item.registroPatronalID)
            .then((Response: ResponseData) => {
              item.registroPatronalEstatusID = 2;
              Object.assign(this.items[this.editedIndex], item);
              this.text = "Registro autorizó";
              this.snackbar = true;
              this.color = "success";
              this.resetIndexItem();
            })
            .catch((e: Error) => {
              this.$logger.warn(e);
              this.text =
                "No se autorizó el registro, intente de nuevo más tarde";
              this.snackbar = true;
              this.color = "red darken-2";
              this.resetIndexItem();
            });
          break;
        case 3:
          dataService
            .approveDocuments(item.docID)
            .then((Response: ResponseData) => {
              item.docEstatusID = 2;
              Object.assign(this.items[this.editedIndex], item);
              this.text = "Registro autorizó";
              this.snackbar = true;
              this.color = "success";
              this.resetIndexItem();
            })
            .catch((e: Error) => {
              this.$logger.warn(e);
              this.text =
                "No se autorizó el registro, intente de nuevo más tarde ";
              this.snackbar = true;
              this.color = "red darken-2";
              this.resetIndexItem();
            });
          break;
        default:
          break;
      }
    },
    // Selecciona el item a rechazar y abre modal
    refuseItem(item: any) {
      switch (this.docuementoSeccion.documentoOrden) {
        case 1:
          this.keyFileTempRefuse = item.registroSTPSBucketKeyFile;
          break;
        case 2:
          this.keyFileTempRefuse = item.registroPatronalBucketKeyFile;
          break;
        case 3:
          this.keyFileTempRefuse = item.docBucketKeyFile;
          break;
        default:
          break;
      }
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogRefuse = true;
    },
    // Cierra modal de rechazo al confirmar
    RefuseItemConfirm() {
      this.closeRefuse();
    },
    // Cierra modal de rechazo
    closeRefuse() {
      this.dialogRefuse = false;
      this.resetIndexItem();
    },
    // Actualiza el item rechazado
    saveItemRefuse() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
      }
      this.closeRefuse();
    },
    // Se limpia el item seleccionado
    resetIndexItem() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        this.editedIndex = -1;
      });
    },
    // Controla la modificacion del archivo
    updateEnabledEdit() {
      this.enabledEdit = 1;
    },
    // Se busca el listado de los registros STPS
    // para el formulario de actividades
    searchSTPSSelet() {
      if (this.isActivities && this.registroSTPS.length == 0) {
        dataService
          .getActivitiesProvider(this.proveedor.userID)
          .then((Response: ResponseData) => {
            this.registroSTPS = Object.assign({}, Response.data.data);
            this.registroSTPS = Response.data.data;
          });
      }
    },
  },
});
